import { readMe, type RestClient } from '@directus/sdk';
import { derived, writable, type Readable } from 'svelte/store';
import type { LoginStatus } from './PicpeccAuth';

// Placeholder for the actual store
let innerMe: Readable<Me | null> = {
	subscribe: (run, invalidate) => {
		throw new Error('MeService not initialized');
	}
};
export const me: Readable<Me | null> = {
	subscribe: (run, invalidate?) => innerMe.subscribe(run, invalidate)
};

export class MeService {
	constructor(
		directus: RestClient<any>,
		private loginStatus: Readable<LoginStatus>
	) {
		this.me = derived(
			[this.reloadTrigger, this.loginStatus],
			([reloadTrigger, loginStatus], set, update) => {
				if (!loginStatus || !loginStatus.userId) {
					set(null);
					return;
				}

				(async () => {
					try {
						const myUser = await directus.request<Me>(
							readMe({
								fields: [
									'tfa_secret',
									'app_language',
									'name',
									'role',
									'customer',
									'id',
									'points',
									'pin_code',
									{
										'target_audiences.target_audiences_id': [
											'id',
											'chat_enabled',
											'custom_chat_message',
											'main_lang',
											{
												translations: ['*']
											}
										],
										'policies': ['policy'],
									}
								],
								deep: {
									target_audiences: {
										_filter: {
											target_audiences_id: {
												status: 'published'
											}
										}

									},
								}
							})
						);
						set(myUser);
					} catch (e) { }
				})();
			}
		);

		innerMe = this.me;
	}

	public me: Readable<Me | null>;

	private reloadTrigger = writable(0);
	public reload() {
		this.reloadTrigger.update((x) => x + 1);
	}
}

export interface Me {
	tfa_secret: string;
	app_language: string;
	name: string;
	role: string;
	customer: number;
	id: string;
	points: number;
	pin_code: string;
	policies: Array<any>;
	target_audiences: {
		target_audiences_id: {
			id: number;
			chat_enabled: boolean;
			custom_chat_message: string;
			main_lang: string;
			translations: Array<any>;
		};
	}[];
}
